import { useState } from 'react';

import { useEventCallback } from '../../useEventCallback/useEventCallback';
import { Prompt } from '../../../interface/Prompt';
import { partIndexConfig } from '../../../constants/configuration';
import type { Configuration } from '../../../interface/Configuration';

export function useTestNavigator({
    promptList,
    endTestOnLastPrompt,
    configuration,
}: {
    promptList: Prompt[];
    endTestOnLastPrompt: () => boolean;
    configuration: Configuration;
}) {
    const [currentPromptIdx, setCurrentPromptIdx] = useState(-1);
    const [testEnded, setTestEnded] = useState(false);

    const _endTestOnLastPrompt = useEventCallback(endTestOnLastPrompt);

    const startTest = () => setCurrentPromptIdx(0);
    const currentPrompt = promptList[currentPromptIdx];
    const nextPrompt = promptList[currentPromptIdx + 1];
    const currentPartRules = configuration.partRules[partIndexConfig[currentPrompt?.partName] || 0];

    const moveToNextPrompt = (skipToNextPart = false) => {
        if (currentPromptIdx >= promptList.length - 1) {
            const endTest = _endTestOnLastPrompt();

            if (endTest) {
                console.log('Test ended');
                setCurrentPromptIdx(-1);
                setTestEnded(true);
            } else {
                setCurrentPromptIdx((idx) => idx + 1);
            }
        } else {
            setCurrentPromptIdx((idx) => {
                if (skipToNextPart) {
                    const nextPartIdx = promptList.findIndex(
                        (p, i) => p.partName !== promptList[idx].partName && idx < i,
                    );
                    return nextPartIdx >= 0 ? nextPartIdx : promptList.length - 1;
                }
                return idx + 1;
            });
        }
    };

    return {
        currentPrompt,
        nextPrompt,
        currentPromptIdx,
        testEnded,
        currentPartRules,
        startTest,
        moveToNextPrompt,
    };
}
